import Events from '@collectivehealth/cog/dist/events';

import app from 'app';

app.factory('Events', () => Events);
